import { Box, Typography, Divider } from '@mui/material';

function Swot({ swot }) {
    // Handle case where swot or swot.swotAnalysis is undefined
    if (!swot || !swot.swotAnalysis) {
        return null;
    }
    
    const { strengths, weaknesses, opportunities, threats } = swot.swotAnalysis;
    return (
        <Box sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ color: '#444', mb: 2 }}>SWOT</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: 1 }}>
                <Box sx={{ minWidth: 200, flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Strengths</Typography>
                    <Typography variant="body2">{strengths}</Typography>
                </Box>                                    
                <Divider orientation="vertical" sx={{ mr: 1, ml: 1 }} flexItem />
                <Box sx={{ minWidth: 200, flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Weaknesses</Typography>
                    <Typography variant="body2">{weaknesses}</Typography>
                </Box>
                <Divider orientation="vertical" sx={{ mr: 1, ml: 1 }} flexItem />
                <Box sx={{ minWidth: 200, flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Opportunities</Typography>
                    <Typography variant="body2">{opportunities}</Typography>
                </Box>
                <Divider orientation="vertical" sx={{ mr: 1, ml: 1 }} flexItem />
                <Box sx={{ minWidth: 200, flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>Threats</Typography>
                    <Typography variant="body2">{threats}</Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default Swot; 